// https://citrineinformatics.github.io/taurus-documentation/specification/value-types/#empirical-formula
export interface IEmpiricalFormulaValue {
  type: "empirical_formula";
  formula: string;
}

export const empiricalFormulaValueToString = (
  empiricalFormulaValue: IEmpiricalFormulaValue,
): string => {
  // TODO might have to format this in a special way so it looks like a
  // real formula instead of a plain string
  return empiricalFormulaValue.formula;
};
